import React, { useState } from "react";
import "./CounsellorDocumentation.css";
import axios from "axios";
import Swal from "sweetalert2";
import { environment } from "../../environments/environments";
import { useNavigate } from "react-router-dom";
import bgImage from "../../assets/images/brown-background.jpg";

const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB

const CounsellorDocumentation = () => {
  const navigate = useNavigate();
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const validateImageSize = (file) => {
    if (file && file.size > MAX_IMAGE_SIZE) {
      Swal.fire(
        "Too Large!",
        "The selected image exceeds the maximum size of 2 MB.",
        "error"
      );
      return false;
    }
    return true;
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && validateImageSize(file)) {
      setImage(file);
    }
  };

  const handleContinue = async () => {
    if (!image) {
      Swal.fire(
        "No Image Selected",
        "Please choose an image to continue.",
        "warning"
      );
      return;
    }

    setIsLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const _id = userData?.id || userData?._id;

      const formData = new FormData();
      formData.append("counsellor_id", _id);
      formData.append("profile_completion_status", "CounsellorFinalSubmission");
      formData.append("approve_reject", userData?.approve_reject || "");
      formData.append("user_document", image);

      const response = await axios.post(
        `${environment.baseURL}/update-counsellor`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data?.success === true) {
        Swal.fire("Success", response.data.message, "success").then(() =>
          navigate("/CounsellorFinalSubmission")
        );
      } else {
        Swal.fire("Error", response.data.message, "error");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      Swal.fire("Error", "Something went wrong!", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="counsellordoucmentation-container sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>
      <div className="containerall">
        <div className="counsellordoucmentation">
          <p className="instructions">
            Tap to upload an image of your ID proof from the camera or gallery.
          </p>
          <p className="instructions">
            (National ID or Passport or Driving License)
          </p>

          <label className="image-box">
            {image ? (
              <img
                src={URL.createObjectURL(image)}
                alt="Selected"
                className="preview-image"
              />
            ) : (
              <span className="placeholder-text">Click to select image</span>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
          </label>

          <button
            className="continue-button"
            onClick={handleContinue}
            disabled={isLoading}
          >
            {isLoading ? "Uploading..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CounsellorDocumentation;
